// Sorters a datatable column names in its options, for values Tabulator's string sort misorders

import { stripHtml } from "./table_search";

// Cells holding a <time datetime="…">, ordered by that datetime rather than by
// the words shown; a cell without one sorts below every date
export const timeDatetime = (a, b) => {
  const parse = (html) => {
    const m = /datetime="([^"]+)"/.exec(html || "");
    const time = m ? Date.parse(m[1]) : NaN;
    return Number.isNaN(time) ? -Infinity : time;
  };
  const [x, y] = [parse(a), parse(b)];
  return x === y ? 0 : x < y ? -1 : 1;
};

// Values that open with a percentage, like "75%" or "75% (3 of 4)", which a
// string sort puts "100%" before "5%"; text with no number, such as "No
// pupils", sorts below every percentage
export const percent = (a, b) => {
  const parse = (s) => {
    const n = parseFloat(s);
    return Number.isNaN(n) ? -1 : n;
  };
  return parse(a) - parse(b);
};

// Cells ordered by the text they show, a link by its words rather than its
// address, with the numbers in them read as numbers: "8A" before "13A"
const collator = new Intl.Collator("en-GB", {
  numeric: true,
  sensitivity: "base",
});

// A sort compares each cell many times, so each is parsed once
const shownText = new Map();
const textOf = (value) => {
  if (!shownText.has(value)) shownText.set(value, stripHtml(value) ?? "");
  return shownText.get(value);
};

export const naturalText = (a, b) => collator.compare(textOf(a), textOf(b));
